var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1759_329444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3145 4.68548C24.2912 1.66217 20.2732 0 16 0C11.7268 0 7.70879 1.66217 4.68548 4.68548C1.66217 7.70879 0 11.7268 0 16C0 20.2732 1.66217 24.2912 4.68548 27.3145C7.70879 30.3378 11.7268 32 16 32C20.2732 32 24.2912 30.3378 27.3145 27.3145C30.3378 24.2912 32 20.2732 32 16C32 11.7268 30.3378 7.70879 27.3145 4.68548Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7367 12.3101L14.2332 17.8201L12.2634 15.8504C11.9166 15.5036 11.3604 15.5036 11.0135 15.8504C10.6667 16.1972 10.6667 16.7534 11.0135 17.1003L13.6115 19.6982C13.7816 19.8684 14.0107 19.96 14.2332 19.96C14.4557 19.96 14.6847 19.8749 14.8549 19.6982L20.9866 13.5665C21.3334 13.2197 21.3334 12.6635 20.9866 12.3166C20.6463 11.9633 20.0835 11.9633 19.7367 12.3101Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1759_329444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.b40e40eb06e01d07f9c25c0e72434533.svg";
export { ForwardRef as ReactComponent };